import CountryLanding from "@/components/country/CountryLanding";
import { ECUADOR } from "@/data/countryPages";

export default function EOSEcuador() {
  return <CountryLanding country={ECUADOR} />;
}
